import { dashboardConstants } from '@constants/dashboard';

const initialState = {
    dashboard: {
        presence: {
            views: 0,
            viewsDelta: 0,
            engagement: 0,
            engagementDelta: 0,
            conversion: 0,
            conversionDelta: 0,
            distribution: [],
        },
        profilesSync: {
            conflicts: 0,
            notPublished: 0,
            synced: 0,
        },
        optimizationScore: {
            low: 0,
            medium: 0,
            high: 0,
        },
        inboxes: {
            mine: 0,
            open: 0,
            unassigned: 0,
        },
        reviews: {
            averageRating: 0,
            averageRatingDelta: 0,
            collected: 0,
            collectedDelta: 0,
            unrepliedReviews: 0,
            ratingDistribution: [],
        },
        surveyResponses: {
            averageRating: 0,
            averageRatingDelta: 0,
            nps: 0,
            npsDelta: 0,
            responsesCount: 0,
            responsesCountDelta: 0,
            npsDistribution: [],
        },
        socialPosts: {
            count: 0,
            countDelta: 0,
            followers: null,
            followersDelta: null,
            reach28: null,
            reach28Delta: null,
        },
    },
    leaderboard: [],
    recommendations: [],
    loaded: false,
};

// The API nulls sections the user lost permission for, while a stale session may still render their widgets.
function normalizeDashboard(data) {
    const dashboard = { ...initialState.dashboard };
    Object.entries(data ?? {}).forEach(([key, value]) => {
        if (value != null) {
            dashboard[key] = value;
        }
    });
    return dashboard;
}

export function dashboard(state = initialState, action) {
    switch (action.type) {
        case dashboardConstants.DASHBOARD_SUCCESS:
            return { ...state, dashboard: normalizeDashboard(action.data), loaded: true };
        case dashboardConstants.DASHBOARD_ERROR:
            return { ...state, dashboard: initialState.dashboard, loaded: true };
        case dashboardConstants.LEADERBOARD_SUCCESS:
            return { ...state, leaderboard: action.data };
        case dashboardConstants.LEADERBOARD_ERROR:
            return { ...state, leaderboard: [] };
        case dashboardConstants.RECOMMENDATIONS_SUCCESS:
            return { ...state, recommendations: action.data };
        case dashboardConstants.RECOMMENDATIONS_ERROR:
            return { ...state, recommendations: [] };
        case dashboardConstants.SET_RECOMMENDATIONS:
            return { ...state, recommendations: action.data };
        default:
            return state;
    }
}
